import {
  CLEAR_SELECTED_EXECUTION_ID,
  ClearSelectedExecutionId,
  UPDATE_ACTIVE_CLUSTERING_EXECUTION_ID,
  UpdateActiveClusteringExecutionId,
} from 'tabs/topQuestions/lib/top_questions_config/clusteringConfigurationTypes'


export const updateActiveClusteringId = (payload: string): UpdateActiveClusteringExecutionId => ({
  type: UPDATE_ACTIVE_CLUSTERING_EXECUTION_ID,
  payload,
})

export const clearSelectedExecutionId = (): ClearSelectedExecutionId => ({
  type: CLEAR_SELECTED_EXECUTION_ID,
  payload: undefined,
})
